import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext } from '@tanstack/react-router';

import { AriaRouter } from '@/host/AriaRouter';

/** Guards and loaders read the app's one QueryClient (e.g. the cached session). */
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({ component: AriaRouter });
